export const SETTING_ADD_REQUEST = 'SETTING_ADD_REQUEST'
export const SETTING_ADD_SUCCESS = 'SETTING_ADD_SUCCESS'
export const SETTING_ADD_FAIL = 'SETTING_ADD_FAIL'
export const SETTING_ADD_RESET = 'SETTING_ADD_RESET'

export const SETTING_LIST_REQUEST = 'SETTING_LIST_REQUEST'
export const SETTING_LIST_SUCCESS = 'SETTING_LIST_SUCCESS'
export const SETTING_LIST_FAIL = 'SETTING_LIST_FAIL'
export const SETTING_LIST_RESET = 'SETTING_LIST_RESET'

export const SETTING_UPDATE_REQUEST = 'SETTING_UPDATE_REQUEST'
export const SETTING_UPDATE_SUCCESS = 'SETTING_UPDATE_SUCCESS'
export const SETTING_UPDATE_FAIL = 'SETTING_UPDATE_FAIL'
export const SETTING_UPDATE_RESET = 'SETTING_UPDATE_RESET'
